import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from "../../../environments/environment";
import {AuthService} from "@services/auth.service";
import {UserRoles} from "@authentication/user-roles";

interface Link {
  path: string;
  text: string;
  isExternal?: boolean;
}

@Component({
  selector: 'app-admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.scss']
})
export class AdminMenuComponent implements OnInit {
  links: Link[] = [
    {
      path: 'import-order',
      text: $localize`:@@admin.menu.import-order:Läs in planerad beställning`
    },
    {
      path: 'import-timetable',
      text: $localize`:@@admin.menu.import-timetable:Hantera linjer och linjevarianter`
    },
    {
      path: 'connect-routevariant',
      text: $localize`:@@admin.menu.connect-routevariant:Koppla linjevarianter`
    },
    {
      path: 'missingVehicleStopEvents',
      text: $localize`:@@admin.menu.missing-vehicleatstopevents:Felplacerade hållplatser?`
    },
  ];

  path: string;
  route: Router;

  constructor(private router: Router, private authService: AuthService) {
    this.route = router;

    if(this.authService.userHasAnyRole([UserRoles.NobinaLeveransansvarig, UserRoles.NobinaTrafikledare])){
      this.links.push({
        path: '/route/customer-display-admin',
        text: $localize`:@@admin.menu.user-display-admin:Hantera kunddisplay`,
        isExternal: true
      });
    }
  }

  ngOnInit() {
  }

}
